module.exports = __webpack_public_path__ + "img/4.c0810bb6.jpg";